import { useState } from "react";
import styles from "../styles/theme";

const eyeOpen = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
    <circle cx="12" cy="12" r="3"/>
  </svg>
);
const eyeClosed = (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    <line x1="1" y1="1" x2="23" y2="23"/>
  </svg>
);

const eyeBtn = {
  position: 'absolute', right: 0, top: 0, bottom: 0, width: 48,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  background: 'transparent', border: 'none', cursor: 'pointer', padding: 0,
};

export default function LoginPage({ authForm, setAuthForm, authError, authLoading, onLogin, onBack, onSwitchToSignup, onForgotPassword, resetSuccess }) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div style={styles.formWrap} data-form-wrap>
      <button style={styles.backBtn} data-back-btn onClick={onBack}>{"\u2190"} Back</button>
      <div style={styles.formCard} data-form-card>
        <h2 style={styles.formTitle} data-form-title>Log In</h2>
        <div style={styles.formFields} data-form-fields>
          {resetSuccess && (
            <div style={{ background: '#1a4a2e', border: '1px solid #4ade80', borderRadius: 8, padding: '14px 18px', color: '#4ade80', fontSize: 14 }}>
              {"\u2705"} Password reset successfully! Please log in with your new password.
            </div>
          )}
          <label style={styles.label}>Email</label>
          <input style={styles.input} type="email" placeholder="you@email.com" value={authForm.email} onChange={e => setAuthForm(f => ({ ...f, email: e.target.value }))} />
          <label style={styles.label}>Password</label>
          <div style={{ position: 'relative' }}>
            <input style={{ ...styles.input, paddingRight: 48 }} type={showPassword ? 'text' : 'password'} placeholder="Your password" value={authForm.password} onChange={e => setAuthForm(f => ({ ...f, password: e.target.value }))} />
            <button type="button" onClick={() => setShowPassword(v => !v)} style={eyeBtn} tabIndex={-1} aria-label={showPassword ? 'Hide password' : 'Show password'}>
              {showPassword ? eyeClosed : eyeOpen}
            </button>
          </div>
          {authError && <div style={styles.errorMsg}>{"\u26A0\uFE0F"} {authError}</div>}
          <div style={{ textAlign: 'right', marginTop: -4 }}>
            <span style={{ color: '#d97706', cursor: 'pointer', fontSize: 13 }} onClick={onForgotPassword}>Forgot Password?</span>
          </div>
          <button style={styles.btnPrimary} data-btn-primary onClick={onLogin} disabled={authLoading}>
            {authLoading ? 'Logging in...' : 'Log In'}
          </button>
          <p style={{ color: '#7a7570', fontSize: 13, textAlign: 'center' }}>
            Don't have an account?{' '}
            <span style={{ color: '#d97706', cursor: 'pointer' }} onClick={onSwitchToSignup}>Sign up</span>
          </p>
        </div>
      </div>
    </div>
  );
}
